import Articles from './Articles';
import ClientTestimonies from './ClientTestimonies';
import Contact from './Contact';
import Tabs from './Tabs';
import Faqs from './Faqs';
import Loader from './Loader';
import Checkbox from './Checkbox';

export { Articles, ClientTestimonies, Contact, Tabs, Faqs, Loader, Checkbox };